import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    component: Home
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

// @ts-expect-error no types for vue-roon-login
import RoonAuth from "@roonlabs/vue-roon-login";
RoonAuth.install(router);

import Auth from "../core/auth";
import * as AuthStore from "../store/modules/auth";

router.beforeEach(async (to, from, next) => {
  if (to.path === "/licb") {
    next();
    return;
  }
  if (!AuthStore.getters.isAuthenticated) {
    try {
      const user = await Auth.me();
      AuthStore.mutations.setUser(user);
    } catch {
      // Not authenticated — vue-roon-login guard will handle redirect
    }
  }
  next();
});

export default router;
